import {
    Skeleton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Button,
  } from "@mui/material";
  import React, { useMemo, useState, useCallback } from "react";
  import classes from "./SimpleTable.module.scss";
  
  const PAGE_SIZE = 1000;
  
  const SimpleTable = React.memo(({ data, title, firstColumn }) => {
    const [visibleRows, setVisibleRows] = useState(PAGE_SIZE);
  
    // Reset visibleRows if data changes
    React.useEffect(() => {
      setVisibleRows(PAGE_SIZE);
    }, [data]);
  
    const columns = useMemo(() => {
      if (!data || data.length === 0) {
        return [];
      }
      let cols = Object.keys(data[0]);
      if (cols.includes(firstColumn)) {
        cols = [firstColumn, ...cols.filter((column) => column !== firstColumn)];
      }
      return cols;
    }, [data, firstColumn]);
  
    const rows = useMemo(() => data || [], [data]);
  
    const handleLoadMore = useCallback(() => {
      setVisibleRows((prev) => Math.min(prev + PAGE_SIZE, rows.length));
    }, [rows.length]);
  
    if (!data || data.length === 0) {
      return <Skeleton />;
    }
  
    return (
      <div  className={classes.tableWrapper}>
        {title && <h3 className={classes.title}>{title}</h3>}
        <TableContainer className={classes.tableContainer}>
          <Table stickyHeader>
            <TableHead className={classes.stickyHeader}>
              <TableRow>
                {columns.map((column, index) => (
                  <TableCell className={classes.rowHeader} key={index}>
                    {column
                      .replace(/_/g, " ")
                      .replace(/\b\w/g, (char) => char.toUpperCase())}
                    {/* Removes underscores and capitalizes */}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.slice(0, visibleRows).map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  {columns.map((column, colIndex) => (
                    <TableCell key={`${rowIndex}-${colIndex}`}>
                      {row[column]}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {visibleRows < rows.length && (
          <div className={classes.loadMore}>
            <Button variant="outlined" onClick={handleLoadMore}>
              Load More
            </Button>
          </div>
        )}
      </div>
    );
  });
  
  export default SimpleTable;
  